export default "__VITE_ASSET__BZhkomzG__"